import { render, staticRenderFns } from "./DecisionDiamondCardMenu.vue?vue&type=template&id=3cce2672&scoped=true"
import script from "./DecisionDiamondCardMenu.vue?vue&type=script&lang=js"
export * from "./DecisionDiamondCardMenu.vue?vue&type=script&lang=js"
import style0 from "./DecisionDiamondCardMenu.vue?vue&type=style&index=0&id=3cce2672&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cce2672",
  null
  
)

export default component.exports